import { commonRegx } from "xcommon-node/src/common/commonRegx";
import { EntityGoal } from "../../entity/EntityGoal";

export class DtoGoalsGetRes extends EntityGoal {
  public items: EntityGoal[]  = [];
}
